const LEAF = "M12 2C6 6 4 11 6 17c1.5 3 4 5 6 5 2 0 4.5-2 6-5 2-6 0-11-6-15zm0 4v14";
const COLORS = ["#34C759", "#30A14E", "#7ED957", "#A8E063", "#FF7AB6", "#FFD60A", "#248A3D"];

export function plantConfetti(count = 46) {
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
  const w = window.innerWidth, h = window.innerHeight;
  for (let i = 0; i < count; i++) {
    const s = 14 + Math.random() * 16;
    const c = COLORS[i % COLORS.length];
    const flower = i % 7 === 0;
    const el = document.createElement("div");
    el.innerHTML = flower
      ? `<svg viewBox="0 0 24 24" width="${s}" height="${s}"><g fill="${c}">${[0, 72, 144, 216, 288].map((r) => `<ellipse cx="12" cy="6.5" rx="3.4" ry="5" transform="rotate(${r} 12 12)"/>`).join("")}<circle cx="12" cy="12" r="2.6" fill="#FFD60A"/></g></svg>`
      : `<svg viewBox="0 0 24 24" width="${s}" height="${s}"><path d="${LEAF}" fill="${c}" stroke="rgba(0,0,0,0.12)" stroke-width="0.8"/></svg>`;
    Object.assign(el.style, { position: "fixed", left: `${w / 2}px`, top: `${h * 0.55}px`, pointerEvents: "none", zIndex: 80, willChange: "transform" });
    document.body.appendChild(el);
    const ang = (-Math.PI / 2) + (Math.random() - 0.5) * Math.PI * 1.1;
    const v = 260 + Math.random() * 380;
    const dx = Math.cos(ang) * v, dy = Math.sin(ang) * v;
    const rot = (Math.random() - 0.5) * 720;
    const drift = (Math.random() - 0.5) * 160;
    el.animate([
      { transform: "translate(-50%,-50%) scale(0.4) rotate(0deg)", opacity: 0 },
      { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(1) rotate(${rot / 2}deg)`, opacity: 1, offset: 0.35 },
      { transform: `translate(calc(-50% + ${dx + drift}px), calc(-50% + ${dy + h * 0.75}px)) scale(0.9) rotate(${rot}deg)`, opacity: 0 },
    ], { duration: 1900 + Math.random() * 900, delay: Math.random() * 120, easing: "cubic-bezier(.2,.7,.4,1)" }).onfinish = () => el.remove();
  }
  navigator.vibrate?.([10, 40, 10]);
}
